import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {User, UserProfile} from "../models/User";
import {Response} from "../models/Response";
import {environment} from "../../environments/environment";
import { Paginator } from '../models/Paginator';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  /**
   * Autenticación de un usuario.
   *
   * @return Observable<Response<User>> Observable de la respuesta de la autenticación.
   */
  get(id:number): Observable<Response<UserProfile>> {
    return this.http.get<Response<UserProfile>>(`${environment.API_URL}/user/${id}`);
  }

  /**
   * Obtener lista de estudiantes
   *
   * @return Observable<Response<UserProfile[]>> Observable con la lista de estudiantes
   */
  getStudents(): Observable<Response<UserProfile[]>> {
    return this.http.get<Response<UserProfile[]>>(`${environment.API_URL}/user/students`);
  }

  /** Carnets/licencias del alumno (para proponerlo a un examen). */
  getStudentLicenses(userId: number): Observable<Response<any[]>> {
    return this.http.get<Response<any[]>>(`${environment.API_URL}/user/${userId}/licenses`);
  }
}
